import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import api, { apiError } from "../lib/api";
import { Input } from "../components/ui/input";
import { Button } from "../components/ui/button";

export default function Restablecer() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [password2, setPassword2] = useState("");

  const submit = async () => {
    if (password !== password2) { toast.error("Las contraseñas no coinciden"); return; }
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Contraseña restablecida. Inicia sesión.");
      navigate("/login");
    } catch (e) { toast.error(apiError(e)); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-6">
      <div className="w-full max-w-sm space-y-4" data-testid="reset-password-page">
        <h1 className="font-heading text-2xl font-extrabold tracking-tight">Nueva contraseña</h1>
        <Input data-testid="reset-password-input" type="password" placeholder="Nueva contraseña" value={password} onChange={(e) => setPassword(e.target.value)} />
        <Input data-testid="reset-password2-input" type="password" placeholder="Repite la contraseña" value={password2} onChange={(e) => setPassword2(e.target.value)} />
        <Button data-testid="reset-submit-button" onClick={submit} disabled={password.length < 6} className="w-full">Restablecer contraseña</Button>
      </div>
    </div>
  );
}

export function Verificar() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState("Verificando tu email…");

  useEffect(() => {
    api.post("/auth/verify-email", { token: params.get("token") || "" })
      .then(() => { setStatus("¡Email verificado! Redirigiendo…"); setTimeout(() => navigate("/"), 1500); })
      .catch((e) => setStatus(apiError(e)));
  }, []); // eslint-disable-line

  return (
    <div className="min-h-screen flex items-center justify-center">
      <p data-testid="verify-status" className="text-sm font-medium">{status}</p>
    </div>
  );
}
